import partnersData from '../data/partners';
import styles from './PartnerSlider.module.css';

const PartnerSlider = ({ language, copy }) => {
  const sliderPartners = [...partnersData, ...partnersData];

  return (
    <section className={styles.wrapper}>
      <div className={styles.sectionHeading}>
        <h2>{copy.title}</h2>
        <p>{copy.body}</p>
      </div>
      <div className={styles.slider}>
        <div className={styles.track}>
          {sliderPartners.map((partner, index) => (
            <article key={`${partner.id}-${index}`} className={styles.card}>
              {partner.logo && (
                <div className={styles.partnerLogo}>
                  <img src={partner.logo} alt={`${partner.name} logo`} />
                </div>
              )}
              <h3>{partner.name}</h3>
              <p>{partner.desc[language]}</p>
              <a className={styles.partnerLink} href={partner.url} target="_blank" rel="noreferrer">
                {language === 'fr' ? 'Découvrir' : 'Learn more'} →
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSlider;
